<template>
	<div>
		<el-form ref="form" :model="form" :rules="rules" style="padding-right:30px;" :label-width="formLabelWidth">
			<el-form-item label="工单号" prop="code">
				<el-input autocomplete="off" v-model.trim="form.code" maxlength="150" show-word-limit></el-input>
			</el-form-item>
			<el-form-item label="计划开始时间" prop="plan_begin_time.$date">
				<el-date-picker type="datetime" v-model.trim="form.plan_begin_time.$date" value-format="timestamp" placeholder="选择日期时间"> </el-date-picker>
			</el-form-item>
			<el-form-item label="计划结束时间" prop="plan_end_time.$date">
				<el-date-picker type="datetime" v-model.trim="form.plan_end_time.$date" value-format="timestamp" placeholder="选择日期时间"> </el-date-picker>
			</el-form-item>
			<el-form-item label="准备时间" prop="pre_time">
				<el-input-number v-model.trim="form.pre_time" :min="0" :max="999999"></el-input-number>
				<span style="margin-left:10px;">分钟</span>
			</el-form-item>
			<el-form-item label="总长度" prop="total_len">
				<el-input-number v-model.trim="form.total_len" :min="0" :max="999999999"></el-input-number>
			</el-form-item>
			<el-form-item label="总卷数" prop="roll_num">
				<el-input-number v-model.trim="form.roll_num" :min="0" :max="999999999"></el-input-number>
			</el-form-item>
			<el-form-item label="每卷长度" prop="roll_len">
				<el-input-number v-model.trim="form.roll_len" :min="0" :max="999999999"></el-input-number>
			</el-form-item>
			<el-form-item label="托盘数" prop="plates">
				<el-input-number v-model.trim="form.plates" :min="0" :max="999999"></el-input-number>
			</el-form-item>
			<el-form-item label="生产机台" prop="jt_id">
				<el-select v-model.trim="form.jt_id" placeholder="请选择">
					<el-option-group v-for="group in deviceOptions" :key="group.value" :label="group.label">
						<el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
					</el-option-group>
				</el-select>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	import { workshopRequest } from '@/network/requests/workshop'
	import { jtInfoRequest } from '@/network/requests/jtInfo'
	import { processGroupDetailRequest } from '@/network/requests/processGroupDetail'
	export default {
		data() {
			this.formLabelWidth = '120px'
			return {
				deviceOptions: [],
				workshops: [],
				/**
				 * 工序组中工序。
				 */
				processDetails: [],
				rules: {
					code: [{ required: true, message: '请输入工单号', trigger: 'blur' }],
					roll_num: [
						{ required: true, message: '请输入预计卷数' },
						{ type: 'number', message: '请输入数字类型' },
					],
					plan_begin_time: { $date: [{ required: true, message: '请输入计划开始时间', trigger: 'change' }] },
					plan_end_time: { $date: [{ required: true, message: '请输入计划结束时间', trigger: 'change' }] },
					pre_time: [{ required: true, message: '请输入准备时间', trigger: 'change' }],
					total_len: [
						{ required: true, message: '请输入工单总米数' },
						{ type: 'number', message: '请输入数字类型' },
					],
					roll_len: [
						{ required: true, message: '请输入每卷米数' },
						{ type: 'number', message: '请输入数字类型' },
					],
					jt_id: [{ required: true, message: '请选择机台' }],
					plates: [{ required: true, message: '请输入托盘数' }],
				},
			}
		},
		props: {
			form: {
				type: Object,
			},
		},
		model: {
			prop: 'form',
			event: 'changeForm',
		},
		methods: {
			changeForm() {
				this.$emit('change', this.form)
			},
			editform() {
				this.$refs.form.validate(valid => {
					if (valid) {
						this.$emit('worKEditForm')
					} else {
						return false
					}
				})
			},

			load() {
				var p1 = workshopRequest.queryAll()
				var p2 = jtInfoRequest.queryAll()
				var p3 = processGroupDetailRequest.queryAll({ process_group_id: '' })

				Promise.all([p1, p2]).then(result => {
					var workshops = result[0]
					var devices = result[1]

					console.log('workshops', workshops)
					console.log('devices', devices)

					workshops.forEach((w, i) => {
						var ds = devices.filter(t => t.workshop_id == w._id.$oid)

						var options = ds.map(p => ({
							value: p._id.$oid,
							label: p.name,
						}))

						this.deviceOptions.push({
							value: w._id.$oid,
							label: w.name,
							options: options,
						})
					})

					console.log('加载机台.')
				})
			},
		},
		created() {
			this.load()
		},
	}
</script>

<style></style>
